import ExecutionsView from '../ExecutionsView.vue'
import ConfirmationsPage from '../Pages/ConfirmationsPage.vue'

// DEF-ADM-024 — procesos batch que lanza el operador a mano. Viven en
// Administración (nivel 1): la pantalla elige su propia ciudad, no depende de
// la activa. Por ahora solo hay confirmaciones; el grupo queda para los que vengan.
const routes = [
  {
    path: '/administracion/ejecuciones',
    component: ExecutionsView,
    name: 'executions',
    children: [
      {
        path: 'confirmaciones',
        name: 'executions-confirmations',
        component: ConfirmationsPage
      }
    ]
  }
]

export default routes
